import { type GroupCollectionsClientInterface } from './groupCollectionsClient.types';
import CorporateGroupCollectionsClient from './corporateGroupCollectionsClient';
import OrgUnitGroupCollectionsClient from './orgUnitGroupCollectionsClient';
import type { ClientContext } from '~/services/contextClient';

export default class GroupCollectionsClientFactory {
    static createClient(context: Omit<ClientContext, 'groupId'>): GroupCollectionsClientInterface {
        if (!context.orgUnitId) {
            return new CorporateGroupCollectionsClient(context.teamId);
        }

        return new OrgUnitGroupCollectionsClient(context.teamId, context.orgUnitId);
    }
}
